"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectionController = void 0;
const DataType_1 = __importDefault(require("@opsbase/lib-datatype/DataType"));
const react_1 = __importStar(require("react"));
const SelectionContext_1 = __importDefault(require("../useSelection/SelectionContext"));
const SelectionActionsContext_1 = __importDefault(require("../useSelectionActions/SelectionActionsContext"));
const initialSelections = Object.values(DataType_1.default).reduce((p, c) => (Object.assign(Object.assign({}, p), { [c]: { selecteds: [] } })), {});
function SelectionController({ children }) {
    const [changed, setChanged] = (0, react_1.useState)();
    const selectionRegistry = (0, react_1.useRef)(initialSelections);
    const getSelectionClone = (0, react_1.useCallback)((dataType) => {
        if (!selectionRegistry.current[dataType])
            selectionRegistry.current[dataType] = { selecteds: [] };
        const c = { selecteds: [] };
        c.selecteds = [...selectionRegistry.current[dataType].selecteds];
        return c;
    }, []);
    const setSelection = (0, react_1.useCallback)((dataType) => (items) => {
        selectionRegistry.current[dataType] = { selecteds: items };
        selectionRegistry.current = Object.assign({}, selectionRegistry.current);
        setChanged(new Date());
    }, []);
    const toggleSelection = (0, react_1.useCallback)((dataType) => (items, force) => {
        const selection = getSelectionClone(dataType);
        let it = selection.selecteds;
        // For every item being toggled
        items.forEach(item => {
            // If not forcing OFF and the item isn't NOT found
            if (force !== false && !it.find(f => f.id === item.id)) {
                // Add it
                it.push(Object.assign({}, item));
            }
            // Otherwise, if we're not forcing ON
            else if (!force) {
                // Remove it
                it = it.filter(f => f.id !== item.id);
            }
        });
        // Set the new Items
        setSelection(dataType)(it);
    }, [getSelectionClone, setSelection]);
    const clearSelection = (0, react_1.useCallback)((dataType) => () => {
        setSelection(dataType)([]);
    }, [setSelection]);
    const actionsCtx = (0, react_1.useMemo)(() => ({
        setSelection,
        toggleSelection,
        clearSelection,
    }), [clearSelection, setSelection, toggleSelection]);
    const ctx = (0, react_1.useMemo)(() => selectionRegistry.current, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [changed]);
    return (react_1.default.createElement(SelectionActionsContext_1.default.Provider, { value: actionsCtx },
        react_1.default.createElement(SelectionContext_1.default.Provider, { value: ctx }, children)));
}
exports.SelectionController = SelectionController;
exports.default = SelectionController;
